import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { typography, colors } from '../../styles';
import Carousel from '../../components/Carousel';

const styles = css`
  width: 100%;
  padding: 0 0 0 0;
  position: relative;
  overflow: hidden;
  @media (min-width: 992px) {
    height: calc(75vh + 100px);
    margin: 0 0 0 0;
  }
  .Carousel_image {
    margin-top: 70px;
    @media (min-width: 992px) {
      margin-top: 100px;
      & img {
        height: 75vh;
        object-fit: cover;
        object-position: center center;
      }
    }
  }
  .HeroImage_headlineWrapper {
    width: 100%;
    padding: 20px 0 25px 0;
    text-align: center;
    position: relative;
    @media (min-width: 992px) {
      width: 850px;
      left: 50%;
      margin-left: -425px;
      position: absolute;
      padding: 30px 30px 0 30px;
      bottom: calc(50% - 200px);
      top: auto;
    }
    &::after {
      content: '';
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: ${colors.color2Darkest};
      @media (min-width: 992px) {
        opacity: .85;
      }
    }
  }
  .HeroImage_headline {
    text-align: center;
    color: #FFFFFF;
    font-family: ${typography.Serif};
    margin: 0 15px 10px 15px;
    font-size: 32px;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 50px;
      margin: 0 0 25px 0;
    }
  }
  .HeroImage_btn {
    margin: 0;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 2px;
    position: relative;
    z-index: 1;
    border: 0;
    background-color: ${colors.color3Darker};
    color: #FFFFFF;
    @media (min-width: 992px) {
      margin: 0 0 -22px 0;
    }
  }
  .Carousel_imageButtonLeft, .Carousel_imageButtonRight {
    @media (min-width: 992px) {
      top: 35vh;
    }
  }
`;

function HeroImage({ page }) {
  return (
    <div
      className={styles}
    >
      <Carousel
        autoplay
        interval={5000}
        items={get(page, 'header_images', [])}
        mainImageProps={{
          width: 2000,
          height: 2000 * 0.5625,
          exact: true,
        }}
      />
      <div className="HeroImage_headlineWrapper">
        <h2 className="HeroImage_headline">
          {get(page, 'header_headline')}
        </h2>
        <Link name="plans" className="btn HeroImage_btn">Browse Our Floor Plans</Link>
      </div>
    </div>
  );
}

HeroImage.propTypes = {
  page: PropTypes.object.isRequired,
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroImage.js